module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.documents), function(document) {
    return _c('div', {
      key: document.title,
      staticClass: "pa-3 item-pulse border-transparent transition clickable hoverable document-item",
      staticStyle: {
        "border-radius": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.documentClicked(document)
        }
      }
    }, [(!document.received) ? [(!document.received) ? _c('v-btn', {
      staticClass: "big-tick",
      staticStyle: {
        "margin-top": "-15px",
        "margin-right": "-15px"
      },
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.markAsReceived(document)
        }
      }
    }, [_vm._v("check_circle")])], 1) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(document.name))]), _vm._v(" "), _c('span', {
      staticClass: "elevation-1 ",
      staticStyle: {
        "background-color": "darkorange",
        "padding": "2px 5px 2px 5px",
        "border-radius": "3px",
        "color": "white",
        "font-weight": "bold",
        "margin-left": "4px",
        "font-size": "0.85em",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                " + _vm._s(document.title) + "\n            ")]), _c('br'), _vm._v("\n\n            " + _vm._s(document.description) + "\n            "), (document.download) ? [_c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "href": document.download,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return false($event)
        }
      }
    }, [_c('button', {
      staticStyle: {
        "margin-top": "5px",
        "margin-bottom": "0px",
        "color": "#444",
        "background-color": "white",
        "border-radius": "3px",
        "border": "solid 1px #c0c0c0",
        "padding": "5px 18px 5px 18px",
        "user-select": "none"
      }
    }, [_vm._v("Download")])])] : _vm._e()] : [_c('b', [_vm._v(_vm._s(document.name))]), _vm._v(" "), _c('span', {
      staticClass: "elevation-1 ",
      staticStyle: {
        "background-color": "green",
        "padding": "2px 5px 2px 5px",
        "border-radius": "3px",
        "color": "white",
        "font-weight": "bold",
        "margin-left": "4px",
        "font-size": "0.85em",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                Received\n            ")])]], 2)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6839f1ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SupplierChecklist/ChecklistItems.vue
// module id = 2583
// module chunks = 1